import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

export default function RegisterUser() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!name || !email || !password) {
            MySwal.fire({
                icon: "error",
                title: "Missing Fields",
                text: "All fields are required.",
                confirmButtonColor: "#B39359",
            });
            setIsLoading(false);
            return;
        }

        try {
            const response = await axios.post(
                "https://ligasos-laravel.ligasos.co/api/register",
                { name, email, password }
            );

            if (response.status === 200 || response.status === 201) {
                MySwal.fire({
                    icon: "success",
                    title: "Account Created!",
                    text: "Your account has been registered successfully.",
                    confirmButtonColor: "#B39359",
                    timer: 1800,
                    showConfirmButton: false,
                }).then(() => {
                    navigate("/login"); // بعد التسجيل بنروح لتسجيل الدخول
                });
            } else {
                throw new Error("Unexpected response status: " + response.status);
            }
        } catch (err) {
            MySwal.fire({
                icon: "error",
                title: "Registration Failed",
                text:
                    err.response?.data?.message ||
                    err.message ||
                    "Please check your inputs.",
                confirmButtonColor: "#B39359",
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <div className="bg-[#0B2C3D] p-8 sm:p-10 rounded-2xl shadow-xl w-full max-w-md transform transition-all duration-500 hover:shadow-2xl">
                <div className="flex justify-center mb-8">
                    <img
                        src={require("../../assets/logo/logo.svg").default}
                        alt="Logo"
                        className="h-12 w-auto"
                    />
                </div>
                <h2 className="text-3xl font-extrabold text-center text-white mb-6 tracking-tight">
                    Create Account
                </h2>
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label
                            htmlFor="name"
                            className="block text-sm font-medium text-white"
                        >
                            Name
                        </label>
                        <input
                            id="name"
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            disabled={isLoading}
                            className="mt-1 w-full p-3 rounded-lg border border-[#1A4A5B] bg-[#0B2C3D] text-white focus:border-[#B39359] focus:ring-2 focus:ring-[#B39359] outline-none transition-colors duration-300 placeholder-gray-400"
                            placeholder="Enter your name"
                        />
                    </div>

                    <div>
                        <label
                            htmlFor="email"
                            className="block text-sm font-medium text-white"
                        >
                            Email
                        </label>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            disabled={isLoading}
                            className="mt-1 w-full p-3 rounded-lg border border-[#1A4A5B] bg-[#0B2C3D] text-white focus:border-[#B39359] focus:ring-2 focus:ring-[#B39359] outline-none transition-colors duration-300 placeholder-gray-400"
                            placeholder="Enter your email"
                        />
                    </div>

                    <div>
                        <label
                            htmlFor="password"
                            className="block text-sm font-medium text-white"
                        >
                            Password
                        </label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            disabled={isLoading}
                            className="mt-1 w-full p-3 rounded-lg border border-[#1A4A5B] bg-[#0B2C3D] text-white focus:border-[#B39359] focus:ring-2 focus:ring-[#B39359] outline-none transition-colors duration-300 placeholder-gray-400"
                            placeholder="Enter your password"
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full bg-[#B39359] text-white font-semibold py-3 rounded-lg hover:bg-[#D4A373] transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {isLoading ? "Creating Account..." : "Sign Up"}
                    </button>
                </form>
            </div>
        </div>
    );
}
